import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { PrimaryButton } from './Controls';
import AdminUsersPanel from './AdminUsersPanel';
import AdminProgramsPanel from './AdminProgramsPanel';
import AdminClipsPanel from './AdminClipsPanel';
import AdminAreasPanel from './AdminAreasPanel';
import AdminGenresPanel from './AdminGenresPanel';
import AdminCybozuPanel from './AdminCybozuPanel';
import { User } from './Main';

// タブ識別子
type AdminTab = 'users' | 'programs' | 'clips' | 'areas' | 'genres' | 'cybozu';

// Propsの型定義を追加
interface AdminPageProps {
  user: User;
}

const AdminPage: React.FC<AdminPageProps> = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 現在のURLのハッシュ（#以降）を見てタブを決定する（デフォルトは 'users'）
  const tab = (location.hash.replace('#', '') as AdminTab) || 'users';

  // タブを切り替える関数（URLを書き換える）
  const handleTabChange = (newTab: AdminTab) => {
    navigate(`#${newTab}`, { replace: true });
  };  

  const renderPanel = () => {
    switch (tab) {
      case 'users':
        return <AdminUsersPanel user={user}/>;
      case 'programs':
        return <AdminProgramsPanel />;
      case 'clips':
        return <AdminClipsPanel />;
      case 'areas':
        return <AdminAreasPanel />;
      case 'genres':
        return <AdminGenresPanel />;
      case 'cybozu':
        return <AdminCybozuPanel />;
      default:
        return null;
    }
  };

  return (
    <Box p={2}>
      <Box
        sx={(theme) => ({
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1.5,
          mb: 2,
            justifyContent: 'center',
          backgroundColor: theme.palette.secondary.light,
          p: 2,
          borderRadius: 4,
        })}
      >
        <PrimaryButton
          onClick={() => handleTabChange('users')}
          sx={tab==='users'?{}:{ backgroundColor:'#888', '&:hover':{ backgroundColor:'#666'} }}
        >ユーザー管理</PrimaryButton>
        <PrimaryButton
          onClick={() => handleTabChange('programs')}
          sx={tab==='programs'?{}:{ backgroundColor:'#888', '&:hover':{ backgroundColor:'#666'} }}
        >番組管理</PrimaryButton>
        <PrimaryButton
          onClick={() => handleTabChange('clips')}
          sx={tab==='clips'?{}:{ backgroundColor:'#888', '&:hover':{ backgroundColor:'#666'} }}
        >固定クリップ管理</PrimaryButton>
        <PrimaryButton
          onClick={() => handleTabChange('areas')}
          sx={tab==='areas'?{}:{ backgroundColor:'#888', '&:hover':{ backgroundColor:'#666'} }}
        >エリア登録</PrimaryButton>
        <PrimaryButton
          onClick={() => handleTabChange('genres')}
          sx={tab==='genres'?{}:{ backgroundColor:'#888', '&:hover':{ backgroundColor:'#666'} }}
        >ジャンル登録</PrimaryButton>
        <PrimaryButton
          onClick={() => handleTabChange('cybozu')}
          sx={tab==='cybozu'?{}:{ backgroundColor:'#888', '&:hover':{ backgroundColor:'#666'} }}
        >サイボウズ連携</PrimaryButton>
      </Box>
      <Box sx={{ p:0, minHeight: 240 }}>
        {renderPanel()}
      </Box>
    </Box>
  );
};

export default AdminPage;
